// extracted by css-extract-rspack-plugin
export default {"ItemLink":"Tt8b3","SuggestionsSidebarWrapper":"B9cCx","DashboardWrapper":"uJa_k","HasSidebar":"R0HVW","Root":"o8LKe"};